<template>
  <div>
    <el-alert
      v-if="!createSuccessful && createMsg != ''"
      title="An error happened. The short link is already in use or an invalid character or space was used. Alphanumeric characters only."
      type="error">
    </el-alert>
    <div class="top-block" v-if="!newCode.code">
      <div>
        <div>Enter your desired short link:</div>
        <span class="separaters">nin.codes/</span>
        <el-input id="title" label="hello" class="title-input" placeholder="my-link" v-model="title"></el-input>
      </div>
      <div class="code-input-group">
        <div>Enter your Nintendo Friend Code here:</div>
        <el-input id="first" class="code-box" placeholder="XXXX" maxlength=4 v-model="first"></el-input>
        <div class="separaters">-</div>
        <el-input id="second" class="code-box" placeholder="XXXX" maxlength=4 v-model="second"></el-input>
        <div class="separaters">-</div>
        <el-input id="third" class="code-box" placeholder="XXXX" maxlength=4 v-model="third"></el-input>
      </div>
      <div>
        <el-button @click=submitNewCode() :loading="this.submitting" type="primary">Create</el-button>
      </div>
      <div>
        <span class="desc">
          Nin.Codes allows you to create an easy to remember short link that directs friends to your Nintendo Friend Code. 
          Enter your desired short link where you see 'nin.codes/my-link' and your 12 digit friend code. When you see 
          the confirmation of your short link, you are ready to start sharing! <strong>A link will be provided for future editing so keep it safe!</strong>
        </span>
      </div>
    </div>
    <div v-else>
      <div v-if="this.copied">
        <el-alert
          v-if=copied
          title="Copied to clipboard"
          type="success">
        </el-alert>
      </div>
      <div>
        <div class="top-block">
          <div>
            <div>Your new short link:</div>
          </div>
          <el-card class="box-card" data-clipboard-action="copy" data-clipboard-target="div#code">
            <small>Give this link to your friends:</small>
            <div id="code" value=this.generateShortLink() >{{ this.generateShortLink() }}</div>
            <small>Click to copy</small>
          </el-card>
          <div>
            <div>Friend Code:</div>
            <div class="separaters">{{this.newCode.code.replace(/([a-zA-Z0-9]{4})([a-zA-Z0-9]{4})([a-zA-Z0-9]{4})/, '$1-$2-$3')}}</div>
          </div>
          <el-card class="box-card" data-clipboard-action="copy" data-clipboard-target="div#editlink">
            <strong class="red-text"><em>Save this link to edit your short link</em></strong>
            <div id="editlink" value=this.generateEditLink()>{{ this.generateEditLink() }}</div>
            <small>Click to copy</small>
          </el-card>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.el-button {
  background-color: white;
  color: red;
  font-weight: 700;
  margin: 0.5em 0em 1em 0em;
}
.el-button--primary {
  padding: 0.75em 0.75em 0.75em 0.75em;
}
.code-input-group {
  margin: 1em 0em 0em 0em;
}
.desc {
  font-size: 0.7em;
}
.separaters {
  display: inline-block;
  font-size: 2em;
}
.code-box {
  display: inline-block;
  max-width: 25%;
  margin: 0.7em;
}
.title-input {
  max-width: 45%;
  display:inline-block;
}
.el-card {
  max-width: 88%;
  background-color:white;
  margin: 0.75em 1em 0.75em 1em;
}
.el-card__body {
  padding: 0px;
}
.red-text {
  color: red;
}
</style>

<script>
import axios from '../services/axios';
import ClipboardJS from 'clipboard';

export default {
  name: "CreateCode",
  data() {
    return {
      first: '',
      second: '',
      third: '',
      title: '',
      newCode: {},
      copied: false,
      copiedText: '',
      createSuccessful: false,
      createMsg: '',
      submitting: false,
    };
  },
  created() {
    var clipboard = new ClipboardJS('.box-card');

    clipboard.on('success', (e) => {
      this.copied = true;
      e.clearSelection();
    });

    clipboard.on('error', () => {
      this.error = 'Could not copy';
    });
  },
  methods: {
    submitNewCode() {
      this.submitting = true;
      axios.post('', {
        title: this.title,
        code: `${this.first}${this.second}${this.third}`,
      })
        .then((resp) => {
          this.newCode = {
            title: resp.data.id,
            code: resp.data.code,
            edit: resp.data.edit,
          };
        })
        // eslint-disable-next-line
        .catch((err) => {
          this.submitting = false;
          this.createSuccessful = false;
          this.createMsg = "failed";
        })
    },
    generateEditLink() {
      return `nin.codes/edit/${this.newCode.title}/${this.newCode.edit}`;
    },
    generateShortLink() {
      return `nin.codes/${this.newCode.title}`;
    },
  },
}
</script>
